import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import styled from 'styled-components/macro'

const LogoutButtonComponent = React.lazy(() => loadComponent('orga', 'LogoutButton'))

const StyledDiv = styled.div``

export function LogoutButton() {
    const navigate = useNavigate()

    const onLogout = useCallback(() => {
        navigate('/login')
    }, [navigate])

    return (
        <StyledDiv>
            <LogoutButtonComponent onLogout={onLogout} />
        </StyledDiv>
    )
}
